import { render } from "./EmbedTopNavigation.vue?vue&type=template&id=31715da8"
import script from "./EmbedTopNavigation.vue?vue&type=script&lang=js"
export * from "./EmbedTopNavigation.vue?vue&type=script&lang=js"

import "./EmbedTopNavigation.vue?vue&type=style&index=0&id=31715da8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__